export var FLOW_CHANGE_FLOW_TYPE = 'flow/changeFlow';